/**
 * RNG có seed — bắt buộc để mô phỏng TẤT ĐỊNH.
 * Nhờ nó: chạy 10.000 trận cân bằng, chạy lại ra y hệt, và tái hiện được lỗi.
 */
export class Rng {
  private s: number;

  constructor(seed = 12345) {
    this.s = seed >>> 0 || 1;
  }

  /** mulberry32 — nhanh, đủ tốt cho game. */
  next(): number {
    this.s = (this.s + 0x6d2b79f5) >>> 0;
    let t = this.s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  range(min: number, max: number): number {
    return min + this.next() * (max - min);
  }

  int(min: number, max: number): number {
    return Math.floor(this.range(min, max + 1));
  }

  chance(p: number): boolean {
    return this.next() < p;
  }

  pick<T>(arr: readonly T[]): T {
    return arr[Math.floor(this.next() * arr.length)];
  }

  get state(): number {
    return this.s;
  }

  set state(v: number) {
    this.s = v >>> 0 || 1;
  }
}
